import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

export const usePrefillQuestionValues = <T extends Record<string, string>>({
  fields,
  setValue,
}: {
  fields: (keyof T)[];
  setValue: (values: Partial<T>) => void;
}) => {
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const newParams = new URLSearchParams(searchParams);

    const prefillValues = fields.reduce((acc, field) => {
      const value = newParams.get(field as string);

      if (value) {
        acc[field] = value as T[keyof T];
        newParams.delete(field as string);
      }

      return acc;
    }, {} as Partial<T>);

    setValue(prefillValues);
    setSearchParams(newParams, { replace: true });
  }, []);
};
